import axios from "axios";
import { HOST_URL } from "../constants/Constants";

export const getObjectGroupings = async (category) => {
  const data = await axios.get(HOST_URL + "/objects/groupings", {
    withCredentials: true,
  });
  return data.data;
};

export const getObject = async (category) => {
  const data = await axios.get(HOST_URL + "/objects/object", {
    params: {
      category: category,
    },
    withCredentials: true,
  });

  return data.data;
};

export const getObjects = async (groupingId) => {
  const data = await axios.get(HOST_URL + "/objects/objects", {
    params: {
      groupingId,
    },
    withCredentials: true,
  });

  return data.data;
};

export const getStaticObjectGridData = async (groupingId) => {
  const data = await axios.get(HOST_URL + "/objects/staticGridData", {
    params: {
      groupingId,
    },
    withCredentials: true,
  });
  return data.data;
};

//Todo Rob needs to migrate all the "AssetLibrary" and static object end points including this one into "StaticObjects"
export const getStaticObject = async (muid) => {
  const data = await axios.get(HOST_URL + "/objects/staticObject", {
    params: {
      muid: muid,
    },
    withCredentials: true,
  });

  return data.data;
};

export const getAllStaticObjects = async (muid) => {
  const data = await axios.get(HOST_URL + "/objects/allStaticObjects", {
    params: {
      muid: muid,
    },
    withCredentials: true,
  });

  return data.data;
};

export const getPendingChecklists = async (projectObjectId, muid) => {
  const data = await axios.get(HOST_URL + "/objects/pendingChecklists", {
    params: {
      projectObjectId,
      muid,
    },
    withCredentials: true,
  });

  return data.data;
};

export const updateStaticObjectProperty = async (muid, property, value) => {
  const data = await axios.post(
    HOST_URL + "/objects/staticObjectProperty",
    {
      data: {
        muid,
        property,
        value,
      },
    },
    {
      withCredentials: true,
    }
  );
  return data;
};

export const addStaticObject = async (staticObject) => {
  const data = await axios.post(
    HOST_URL + "/objects/staticObject",
    {
      data: {
        ...staticObject,
      },
    },
    {
      withCredentials: true,
    }
  );
  return data;
};

export const addObject = async (object) => {
  const data = await axios.post(
    HOST_URL + "/objects/object",
    {
      data: {
        ...object,
      },
    },
    {
      withCredentials: true,
    }
  );
  return data;
};

export const addObjectProp = async (objectProperty) => {
  const data = await axios.post(
    HOST_URL + "/objects/objectProperty",
    {
      data: {
        ...objectProperty,
      },
    },
    {
      withCredentials: true,
    }
  );
  return data;
};

//Todo Rob needs to migrate this to ModelObjectsAxios
export const getProjectObject = async (data) => {
  const tempData = await axios.get(HOST_URL + "/objects/projectObject", {
    params: {
      ...data,
    },
    withCredentials: true,
  });

  return tempData.data;
};

//Properties
export const updateProjectObjectPropertiesDynamic = async (data) => {
  // Fixed this function - the withCredentials was in the wrong place
  const tempData = await axios.put(
    HOST_URL + "/objects/projectObjectPropertiesDynamic",
    { data },
    {
      withCredentials: true,
      params: {},
    }
  );
  return tempData.data;
};

export const updateProjectObjectDynamicProperty = async (
  projectObjectId,
  property,
  value
) => {
  await axios.put(
    HOST_URL + "/objects/projectObjectProperty",
    {
      data: {
        projectObjectId,
        property,
        value,
      },
    },
    {
      withCredentials: true,
    }
  );
};

//Schedules
export const updateProjectObjectDynamicProperties = async (data) => {
  const tempData = await axios.put(
    HOST_URL + "/objects/projectObjectPropertiesSchedule",
    { data },
    {
      withCredentials: true,
    }
  );
  return tempData.data;
};

export const getOPMGridData = async (groupingId) => {
  const data = await axios.get(HOST_URL + "/objects/OPMGridData", {
    params: {
      groupingId,
    },
    withCredentials: true,
  });
  return data.data;
};

export const getScheduleProperties = async (groupingId) => {
  const data = await axios.get(HOST_URL + "/objects/properties", {
    params: {
      groupingId,
    },
    withCredentials: true,
  });
  return data.data.filter((o) => o.schedule === true);
};

export const getAllUniqueOpmProps = async () => {
  const data = await axios.get(HOST_URL + "/objects/AllUniqueOpmProps", {
    withCredentials: true,
  });
  return data.data;
};
